import { render, staticRenderFns } from "./PreviewHorizontalProductList.vue?vue&type=template&id=3ec3f834&scoped=true&"
import script from "./PreviewHorizontalProductList.vue?vue&type=script&lang=js&"
export * from "./PreviewHorizontalProductList.vue?vue&type=script&lang=js&"
import style0 from "./PreviewHorizontalProductList.vue?vue&type=style&index=0&id=3ec3f834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec3f834",
  null
  
)

export default component.exports